import { render, staticRenderFns } from "./DetailsJobTitle.vue?vue&type=template&id=1774bc7a&"
import script from "./DetailsJobTitle.vue?vue&type=script&lang=js&"
export * from "./DetailsJobTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports